import { __decorate } from "tslib";
import { attr, html, observable, slotted } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/mixin';
import { debounce } from 'lodash-es';
export const chatBubbleTemplate = html `<template tabindex="0">
  <div class="contents">
    <slot name="attachments"></slot>
    <slot ${slotted('defaultSlot')}></slot>
  </div>

  <slot name="contextual-actions"></slot>
</template>`;
export class ChatBubbleComponent extends ChameleonElementMixin(FoundationElement) {
    constructor() {
        super();
        this.variant = 'default';
        this.type = 'inbound';
        this.isFirst = false;
        this.shortMessage = false;
        this.observerCallback = debounce((entries) => {
            entries.forEach((entry) => {
                if (entry.contentRect.width < 100) {
                    this.shortMessage = true;
                }
                else {
                    this.shortMessage = false;
                }
            });
        }, 100);
        this.defaultSlot = [];
        this.observer = new ResizeObserver(this.observerCallback);
    }
    connectedCallback() {
        super.connectedCallback();
        this.observer.observe(this);
    }
    disconnectedCallback() {
        this.observer.disconnect();
    }
    defaultSlotChanged(_, changed) {
        changed.forEach((entry) => {
            var _a, _b;
            this.shortMessage = ((_a = entry.parentElement) === null || _a === void 0 ? void 0 : _a.offsetWidth) && ((_b = entry.parentElement) === null || _b === void 0 ? void 0 : _b.offsetWidth) < 100 ? true : false;
        });
    }
}
__decorate([
    attr
], ChatBubbleComponent.prototype, "variant", void 0);
__decorate([
    attr
], ChatBubbleComponent.prototype, "type", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ChatBubbleComponent.prototype, "isFirst", void 0);
__decorate([
    attr({ mode: 'boolean', attribute: 'short-message' })
], ChatBubbleComponent.prototype, "shortMessage", void 0);
__decorate([
    observable
], ChatBubbleComponent.prototype, "defaultSlot", void 0);
